<template>
  <div class="expire-statistical" v-if="data.length > 0">
    <SabbaticalItems v-for="(item, index) in data" :key="index" :sabbaticalInfo="item" />
  </div>
  <div v-else class="expire-statistical">{{$t("sabbatical.sabbatical_on_leave")}}</div>
</template>
<script>
import { mapGetters } from "vuex";
// import DatePicker from "@/components/commons/DatePicker";
import moment from "moment";
import SabbaticalItems from "./SabbaticalItems.vue";
export default {
  name: "HistorySabbatical",
  data() {
    return {
      data: []
    };
  },
  components: {
    SabbaticalItems,
  },
  computed: {
    ...mapGetters({
      expireSabbaticalLog: "sabbatical-leave-request/expireSabbaticalLog",
    }),
  },
  methods: {
    async initialLog() {
      await this.getExpireSabbaticalLog();
    },
    async getExpireSabbaticalLog() {
      this.$root.$loading.start();
      await this.$store.dispatch("sabbatical-leave-request/getExpireSabbaticalLog");
      this.$root.$loading.finish();
    },
  },
  async created() {
    await this.getExpireSabbaticalLog();
    var sabbaticalLogList = [];
    for (const item in this.expireSabbaticalLog) {
      var sabbaticalLog = {
        month: "",
        lawBonus: {},
        fixBonus: {},
        otBonus: {},
        sabbaticalSub: {},
        compensationValue:{},
        dateInfo : {},
        dataStartDate:{},
        dataEndDate:{},
        monthCompensation:{}
      };
      this.expireSabbaticalLog[item].forEach((sabbatical, index) => {
        sabbaticalLog.month = sabbatical.month;
        if (sabbatical.reason) {
          sabbaticalLog.fixBonus[index] = {
            'daysOff' : sabbatical.number_days_off,
            'reason' : sabbatical.reason
          };
        }
        if ((sabbatical.ref_type === "" || sabbatical.ref_type === null) && sabbatical.ref_id === null && !sabbatical.reason) {
          sabbaticalLog.lawBonus[index] = sabbatical.number_days_off;
        }
        if (
          sabbatical.ref_type === "App\\Models\\SabbaticalLeaveRequest" &&
          sabbatical.ref_id !== 0
        ) {
          sabbaticalLog.sabbaticalSub[index] = sabbatical.number_days_off;
          sabbaticalLog.dataStartDate[index] = sabbatical.ref.start_time + " " + moment(sabbatical.ref.start_date).format('DD/MM/YYYY')

          sabbaticalLog.dataEndDate[index] = sabbatical.ref.end_time + " " + moment(sabbatical.ref.end_date).format('DD/MM/YYYY')
        }
        if (
          sabbatical.ref_type === "App\\Models\\CompensationTimesheet" &&
          sabbatical.ref_id !== 0
        ) {
          sabbaticalLog.compensationValue[index] =Math.round(sabbatical.number_days_off * 100) / 100;
          sabbaticalLog.dateInfo[index] = moment(sabbatical.ref.created_at).format('DD/MM/YYYY');
          sabbaticalLog.monthCompensation[index] = moment(sabbatical.ref.month).format('MM/YYYY');
        }
        if (
          sabbatical.ref_type === "App\\Models\\OverTimeRequest" &&
          sabbatical.ref_id !== 0
        ) {
          let project_id =  sabbatical.ref.project_id;
          if (sabbaticalLog.otBonus[project_id]) {
            let dayOff = sabbaticalLog.otBonus[project_id];
            dayOff.count += sabbatical.number_days_off;
            sabbaticalLog.otBonus[project_id] = dayOff;
          } else {
            let dayOff = {
              project: sabbatical.ref && sabbatical.ref.project && sabbatical.ref.project.name ? sabbatical.ref.project.name : "",
              count: sabbatical.number_days_off,
            };
            sabbaticalLog.otBonus[project_id] = dayOff;
          }
        }
      });
      sabbaticalLogList.push(sabbaticalLog);
    }
    this.data = sabbaticalLogList;
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.expire-statistical {
  padding: 15px 0 5px;
}
</style>
